import { Middleware } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

import {
  alertsSlice,
  AlertsState,
  setAreAlertNotesVisible,
  setIsAlertsFiltersSidebarOpenAction,
  setIsDevicesAlertsFiltersSidebarOpenAction,
  toggleAreAlertNotesVisible,
  toggleIsAlertsFiltersSidebarOpenAction,
  toggleIsDevicesAlertsFiltersSidebarOpenAction,
  toggleIsFleetsViewAlertsFiltersSidebarOpenAction,
} from './alerts.slice';

export const alertsMiddleware: Middleware = (api) => (next) => (action) => {
  const result = next(action);
  const alertsState = api.getState()?.[alertsSlice.name];

  if (alertsState) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // NOTE: Middleware is executed AFTER given action
    alertsMiddlewares[action?.type]?.(alertsState, action);
  }

  return result;
};

const alertsMiddlewares = {
  [setIsAlertsFiltersSidebarOpenAction.type]: (state: AlertsState) => {
    appStorage.setIsAlertsFiltersSidebarOpen(state.isAlertsFiltersSidebarOpen);
  },

  [toggleIsAlertsFiltersSidebarOpenAction.type]: (state: AlertsState) => {
    appStorage.setIsAlertsFiltersSidebarOpen(state.isAlertsFiltersSidebarOpen);
  },

  [setIsDevicesAlertsFiltersSidebarOpenAction.type]: (state: AlertsState) => {
    appStorage.setIsDevicesAlertsFiltersSidebarOpen(state.isDevicesAlertsFiltersSidebarOpen);
  },

  [toggleIsDevicesAlertsFiltersSidebarOpenAction.type]: (state: AlertsState) => {
    appStorage.setIsDevicesAlertsFiltersSidebarOpen(state.isDevicesAlertsFiltersSidebarOpen);
  },

  [toggleIsFleetsViewAlertsFiltersSidebarOpenAction.type]: (state: AlertsState) => {
    appStorage.setIsFleetsViewAlertsFiltersSidebarOpen(state.isFleetsViewAlertsFiltersSidebarOpen);
  },

  [setAreAlertNotesVisible.type]: (state: AlertsState) => {
    appStorage.setAreAlertNotesVisible(state.areAlertNotesVisible);
  },

  [toggleAreAlertNotesVisible.type]: (state: AlertsState) => {
    appStorage.setAreAlertNotesVisible(state.areAlertNotesVisible);
  },
};
